module.exports = __webpack_public_path__ + "img/maintop.5bae5f0.png";